import { get as getByPath } from 'lodash';

const VMExportMap = {
    props: 'props',
    ['$options.static']: 'static',
    $cssVarsStyle: 'cssVarsStyle',
    $storeState: 'storeState',
    $storeCommit: 'storeCommit',
    $routeCurrent: 'routeCurrent',
    $routeNavigate: 'routeNavigate',
    $eventBus: 'eventBus',
    $eventTrigger: 'eventTrigger',
    $eventListen: 'eventListen',
    $eventCount: 'eventCount',
    $watchStore: 'watchStore',
    $handleError: 'handleError',
    $debugMessage: 'debugMessage',
    isEditorMode: 'isEditorMode',
    $buildCssVarsStyle: 'buildCssVarsStyle',
    $genCssVarsStyle: 'genCssVarsStyle',
    descriptor: 'descriptor',
    $storeMeta: 'storeMeta',
};

/**
 * Widget wcore api wrapper factory
 * @type {import('@goodt-wcore/elem').IElemInstance}
 * @return {import('./widget').Widget}
 */
const widget = (vm) =>
    Object.create(
        {},
        Object.entries(VMExportMap).reduce(
            (acc, [name, exportName]) => ({
                ...acc,
                [exportName]: {
                    enumerable: true,
                    get: () => {
                        const VMProperty = getByPath(vm, name);
                        return typeof VMProperty === 'function' ? VMProperty.bind(vm) : VMProperty;
                    }
                }
            }),
            {}
        )
    );

export { widget };
